import React from 'react';
import { useTranslation } from 'react-i18next';

import LoadThemeComponent from '../../../../base/LoadThemeComponent';
import { GameType, LotteryRuleTier, SetStateFunction } from '../../Types/Types';

import InfoCircleTooltip from 'components/common/InfoCircleTooltip';
import { isPremierDubai } from 'utils/template';

type Props = {
    useCounterClass: boolean;
    gameType: GameType;
    gameTypes: Array<GameType>;
    setGameType?: SetStateFunction<GameType>;
    setLines?: SetStateFunction<Array<any>>;
    setStakes?: SetStateFunction<Array<any>>;
    setPickedNumbers?: SetStateFunction<Array<any>>;
};

function GameTypeSelect({
    useCounterClass,
    gameTypes,
    gameType,
    setGameType = undefined,
    setLines = undefined,
    setStakes = undefined,
    setPickedNumbers = undefined,
}: Props) {
    const { t } = useTranslation();

    function findGameType(slug: string): GameType | undefined {
        return gameTypes.find(
            (gt: GameType): GameType => {
                if (gt.slug === slug) {
                    return gt;
                }

                if (gt.lottery_rule_tiers && gt.lottery_rule_tiers.length > 0) {
                    const foundElement = gt.lottery_rule_tiers.find(
                        (lotteryRuleTier: LotteryRuleTier) => lotteryRuleTier.slug === slug
                    );
                    if (foundElement) {
                        return gt;
                    }
                }
                return undefined;
            }
        );
    }

    function setGameTypeAndResetLines(slug: string) {
        const newGameType = findGameType(slug);
        if (newGameType) {
            setGameType(newGameType);
            setLines([]);
            setStakes([]);
            setPickedNumbers([]);
        }
    }

    const baseView = () => (
        <div className={`col-12 ${useCounterClass ? 'col-md-6 pl-md-3' : ''} col-lg pl-lg-0 pr-lg-2 purchase-opt-col`}>
            <div className="card options-card d-md-flex h-100">
                <div className="card-header">
                    {t('playPicker.selectGameType')}
                    <InfoCircleTooltip
                        content={
                            isPremierDubai()
                                ? t('playPicker.selectGameTypeTooltipDubai')
                                : t('playPicker.selectGameTypeTooltip')
                        }
                    />
                </div>

                <div className="card-body">
                    <select
                        name="gameType"
                        id="game-type"
                        className="form-control"
                        defaultValue={gameType.slug}
                        onChange={(event) => setGameTypeAndResetLines(event.target.value)}
                    >
                        {gameTypes.map((gt) => (
                            <option key={gt.slug} value={gt.slug}>
                                {t(`gameTypes.${gt.slug}`)}
                            </option>
                        ))}
                    </select>
                </div>
            </div>
        </div>
    );

    const defaultView = () => (
        <div className="col-12">
            <div className="card options-card d-md-flex h-100">
                <div className="card-header">
                    {t('playPicker.selectGameType')}
                    <InfoCircleTooltip
                        content={
                            isPremierDubai()
                                ? t('playPicker.selectGameTypeTooltipDubai')
                                : t('playPicker.selectGameTypeTooltip')
                        }
                    />
                </div>

                <div className="card-body">
                    <select
                        name="gameType"
                        id="game-type"
                        className="form-control"
                        defaultValue={gameType.slug}
                        onChange={(event) => setGameTypeAndResetLines(event.target.value)}
                    >
                        {gameTypes.map((gt) => (
                            <option key={gt.slug} value={gt.slug}>
                                {t(`gameTypes.${gt.slug}`)}
                            </option>
                        ))}
                    </select>
                </div>
            </div>
        </div>
    );

    return <LoadThemeComponent defaultView={defaultView} baseView={baseView} />;
}

export default GameTypeSelect;
